<template>
  <div>
    <div class="flex items-center justify-between !mb-4">
      <b>Selected Equipment</b>
      <SeraButton
        text="Clear Selection"
        @click="$emit('clear-selection', equipment)"
      />
    </div>
    <slot name="equipmentCard">
      <EquipmentCard
        class="mt-6"
        v-bind="equipment"
        :address="addressLabel"
        default-collapsed
      />
    </slot>
  </div>
</template>

<script>
import EquipmentCard from "serviceshift-ui/components/Equipment/EquipmentCard.vue";
import * as EquipmentTypes from "serviceshift-ui/shared/src/classes/equipment";
import { fullAddress } from "serviceshift-ui/shared/src/mixins";

import SeraButton from "../../../components/Button.vue";
export default {
  name: "EquipmentRequestPresentation",
  components: {
    SeraButton,
    EquipmentCard
  },
  props: {
    /** @type {{ new (): EquipmentTypes.Equipment }} */
    equipment: {
      type: Object,
      default: null,
      required: true
    }
  },
  emits: ["clear-selection"],
  computed: {
    addressLabel() {
      if (!this.equipment || !this.equipment?.address) return "--";
      return fullAddress(this.equipment.address);
    }
  }
};
</script>

<style lang="scss" scoped>
.form-cont {
  border-radius: 0 0 4px 4px;
}
</style>
